import React, { Fragment, useState, useEffect } from "react";
import tools from "../../components/tools/tools";
import Select from '../../components/select'

const Default = ({
    datos,
    onClickRefresh
}) => {
    const [catalogos, setCatalogos] = useState([])
    const [selects, setSelects] = useState({
        listExpo: {},
        listTipoCarnet: { label: datos.TIPO_CARNET_TEXT, clave: datos.TIPO_CARNET },
        listGenero: { label: datos.GENERO, clave: datos.ID_CG }
    })
    const [indice, setIndice] = useState(0); // Define 'indice'
    const [datosState, setDatos] = useState(datos); // Replace 'setDatos' with 'setDatos' from state

    // Tipos y ocupaciones (mínimo para editar ocupación)
    const TIPOS_OCUPACION = [
        { clave: "01", label: "01 - Cultivo, crianza y aprovechamiento" },
        { clave: "02", label: "02 - Extracción y suministro" },
        { clave: "03", label: "03 - Construcción" },
        { clave: "04", label: "04 - Tecnología" },
        { clave: "05", label: "05 - Procesos industriales" },
        { clave: "06", label: "06 - Transporte" },
        { clave: "07", label: "07 - Provisión de bienes y servicios" },
        { clave: "08", label: "08 - Gestión y soporte administrativo" },
        { clave: "09", label: "09 - Salud y protección social" },
        { clave: "10", label: "10 - Comunicación" },
        { clave: "11", label: "11 - Desarrollo y extensión del conocimiento" }
    ];

    const OCUPACIONES = {
        "01": [ { clave: "01.1", label: "01.1 - Agricultura y silvicultura" } ],
        "02": [ { clave: "02.1", label: "02.1 - Exploración" } ],
        "03": [ { clave: "03.1", label: "03.1 - Planeación y dirección de obras" } ],
        "04": [ { clave: "04.4", label: "04.4 - Informática" } ],
        "05": [ { clave: "05.1", label: "05.1 - Procesamiento y fabricación" } ],
        "06": [ { clave: "06.1", label: "06.1 - Ferroviario" } ],
        "07": [ { clave: "07.1", label: "07.1 - Comercio" } ],
        "08": [ { clave: "08.1", label: "08.1 - Bolsa, banca y seguros" } ],
        "09": [ { clave: "09.1", label: "09.1 - Servicios médicos" } ],
        "10": [ { clave: "10.1", label: "10.1 - Publicación" } ],
        "11": [ { clave: "11.1", label: "11.1 - Investigación" } ],
    };

    const [ocupacionesDisponibles, setOcupacionesDisponibles] = useState([])

    const onClickEnviar = () => {
        const formCarnet = tools.getForm('formCarnet', { claveEtiquetas: `.txtVacios`, ignore: ['txtCorreo', 'txtWhatsapp', 'listGenero', 'txtCorreo'] })

        if (formCarnet.isEmtyCount) {
            return tools.notie.alert({
                type: 'warning', // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral']
                text: `Los datos del carnet no pueden estar vacíos`,
                time: 3, // optional, default = 3, minimum = 1,
                position: 'top' // optional, default = 'top', enum: ['top', 'bottom']
            })
        }

        fetch('/rt_mesaregistro_registro', {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                idRc: datos.ID_RC,
                idRac: datos.ID_RAC,
                // listTipoCarnet: selects.listTipoCarnet.clave,
                formCarnet: formCarnet.data
            })
        })
            .then((response) => response.json())
            .then((response) => {
                if (!response.estado) {
                    return tools.notie.alert({
                        type: 'warning', // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral']
                        text: `Detalle en el servidor, favor de contactar a soporte técnico`,
                        time: 3, // optional, default = 3, minimum = 1,
                        position: 'top' // optional, default = 'top', enum: ['top', 'bottom']
                    })
                }

                if (response.estado && response.existe) {
                    return tools.notie.alert({
                        type: 'warning', // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral']
                        text: `Hay usuarios que ya existen, favor de revisar sus datos)`,
                        time: 3, // optional, default = 3, minimum = 1,
                        position: 'top' // optional, default = 'top', enum: ['top', 'bottom']
                    })
                }

                // setTimeout(() => window.location.reload('.'), 2000)
                onClickRefresh()
                tools.notie.alert({
                    type: 'success', // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral']
                    text: `Los datos se guardaron correctamente`,
                    time: 2, // optional, default = 3, minimum = 1,
                    position: 'top' // optional, default = 'top', enum: ['top', 'bottom']
                })
            })
            .catch((err) => {
                return tools.notie.alert({
                    type: 'warning', // optional, default = 4, enum: [1, 2, 3, 4, 5, 'success', 'warning', 'error', 'info', 'neutral']
                    text: `Detalle en el servidor, favor de contactar a soporte técnico`,
                    time: 3, // optional, default = 3, minimum = 1,
                    position: 'top' // optional, default = 'top', enum: ['top', 'bottom']
                })
            })
    }

    useEffect(() => {
        let isS = true;

        fetch('/rt_catalogos_mesa', {
            method: 'POST',
            body: JSON.stringify({}),
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then((response) => response.json())
            .then((response) => {
                if (!isS) {
                    return
                }
                setTimeout((s) => {
                    setSelects((s) => ({
                        ...s,
                        listGenero: { label: datos.GENERO, clave: datos.ID_CG }
                    }))
                }, 100)
                setCatalogos((s) => ({
                    ...s,
                    ...response.datos
                }))
                // Inicializar ocupaciones disponibles según el dato existente (si aplica)
                try {
                    const tipoOcup = datos.listTipoOcupacion || (datos.listOcupacion ? String(datos.listOcupacion).split('.')[0] : '')
                    if (tipoOcup && OCUPACIONES[tipoOcup]) {
                        setOcupacionesDisponibles(OCUPACIONES[tipoOcup])
                    }
                } catch (err) {}
            })

        return () => (isS = false);
    }, []);

    return (
        console.log(datos),
        console.log(selects),
        <div>
            <Fragment>
                <div className="datatable-react mt-4 d-flex justify-content-center">
                    <div className="col-sm-12 ">
                        <div>
                            <div className="row">
                                <div className="col-12">
                                    <form className="col-md-12" id={`formCarnet`}>
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="carnet-body">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="form-group">
                                                                <label
                                                                    style={{ fontWeight: 600 }}
                                                                    htmlFor="pnombre"
                                                                >
                                                                    Fecha Registro:
                                                                </label>
                                                                <span className="pl-2">{datos.FECHA_ALTA_RAC_TEXT}</span>
                                                            </div>
                                                            <div className="form-group d-flex justify-content-start">
                                                                {datos.TIPO_CARNET == 1 && datos.ID_PSP == 89? 
                                                                    <img src="/Premium.png" width={100} height={35} />
                                                                :datos.TIPO_CARNET == 1 && datos.ID_PSP == 88?
                                                                    <img src="/Estudiante.png" width={100} height={35} />
                                                                :datos.TIPO_CARNET == 1 && datos.ID_PSP == 87?
                                                                    <img src="/General.png" width={100} height={35} />
                                                                :datos.TIPO_CARNET === 2?
                                                                    <img src="/talleres.jpg" width={100} height={35} />
                                                                :datos.TIPO_CARNET === 3? 
                                                                    <img src="/Expositor.png" width={100} height={35} />
                                                                :datos.TIPO_CARNET === 4? 
                                                                    <img src="/Invitado-Especial.png" width={100} height={35} />
                                                                :datos.TIPO_CARNET === 5? 
                                                                    <img src="/prensa.jpg" width={100} height={35} />
                                                                :datos.TIPO_CARNET === 6? 
                                                                    <img src="/Staff.png" width={100} height={35} />
                                                                :datos.TIPO_CARNET === 7 || datos.TIPO_CARNET === 8? 
                                                                    <img src="/cena.jpg" width={100} height={35} />
                                                                :datos.TIPO_CARNET === 11? 
                                                                    <img src="/Ponente.png" width={100} height={35} />
                                                                :datos.TIPO_CARNET === 12? 
                                                                    <img src="/patrocinador.jpg" width={100} height={35} />
                                                                :datos.TIPO_CARNET === 13? 
                                                                    <img src="/claec.jpg" width={100} height={35} />
                                                                :datos.TIPO_CARNET === 9? 
                                                                    <img src="/conferencias.jpg" width={100} height={35} />
                                                                :datos.TIPO_CARNET === 8? 
                                                                    <img src="/cena.jpg" width={100} height={35} />
                                                                :datos.TIPO_CARNET === 15?
                                                                <img src="/convencionista-soloCB.jpg" width={100} height={35} />
                                                                :datos.TIPO_CARNET === 16?
                                                                <img src="/convencionista-sinC.jpg" width={100} height={35} />
                                                                :datos.TIPO_CARNET === 17?
                                                                <img src="/apoyo-speaker.jpg" width={100} height={35} />
                                                                : <h5><span className="badge badge-primary">Carnet {datos.TIPO_CARNET_TEXT}</span></h5>}
                                                                {/* {datos.TIPO_CARNET === 1 ?
                                                                    <img src="/_Asistentes.png" width={100} height={35} alt="Convencionista" />
                                                                    : datos.TIPO_CARNET === 2 ?
                                                                        <img src="/taller.jpg" width={100} height={35} alt="Taller" />
                                                                            : datos.TIPO_CARNET === 3 ?
                                                                                <img src="/_Expositores.png" width={100} height={35} alt="Expositor" />
                                                                            : datos.TIPO_CARNET === 4 ?
                                                                                <img src="/_Invitados.png" width={100} height={35} alt="Invitado" />
                                                                                : datos.TIPO_CARNET === 5 ?
                                                                                    <img src="/prensa.jpg" width={100} height={35} alt="Prensa" />
                                                                                    : datos.TIPO_CARNET === 6 ?
                                                                                        <img src="/_Staff.png" width={100} height={35} alt="Staff" />
                                                                                        : datos.TIPO_CARNET === 11 ?
                                                                                            <img src="/_Ponentes.png" width={100} height={35} alt="Ponente" />
                                                                                        
                                                                                                : datos.TIPO_CARNET === 7 || datos.TIPO_CARNET === 8 ?
                                                                                                    <img src="/cena.jpg" width={100} height={35} alt="Cena" />
                                                                                                    : datos.TIPO_CARNET === 13 ?
                                                                                                        <img src="/claec.jpg" width={100} height={35} alt="Claec" />
                                                                                                        : datos.TIPO_CARNET === 12 ?
                                                                                                            <img src="/patrocinador.jpg" width={100} height={35} alt="Patrocinador" />
                                                                                                            : <h5><span className="badge badge-primary">Carnet {datos.TIPO_CARNET_TEXT}</span></h5>} */}

                                                                <span className="m-1"></span>
                                                                <Fragment>
                                                                    {datos.IMPRIMIO_CARNET_RAC ?
                                                                        <h5><span className="badge badge-success">{datos.IMPRIMIO_CARNET_TEXT}</span></h5>
                                                                        :
                                                                        <h5><span className="badge badge-warning">{datos.IMPRIMIO_CARNET_TEXT}</span></h5>
                                                                    }
                                                                </Fragment>
                                                                <span className="m-1"></span>
                                                                {datos.ESTATUS_DPG === -1 ?
                                                                    <h5><span className="badge badge-dark">Pago {datos.ESTATUS_DPG_TEXT}</span></h5>
                                                                    : datos.ESTATUS_DPG === 0 ?
                                                                        <h5><span className="badge badge-danger">Pago {datos.ESTATUS_DPG_TEXT}</span></h5>
                                                                        : datos.ESTATUS_DPG === 1 ?
                                                                            <h5><span className="badge badge-light">Pago {datos.ESTATUS_DPG_TEXT}</span></h5>
                                                                            : datos.ESTATUS_DPG === 2 ?
                                                                                <h5><span className="badge badge-success">{datos.ESTATUS_DPG_TEXT}</span></h5>
                                                                                : datos.ESTATUS_DPG === 3 ?
                                                                                    <h5><span className="badge badge-warning">Pago {datos.ESTATUS_DPG_TEXT}</span></h5>
                                                                                    : datos.ESTATUS_DPG === 4 ?
                                                                                        <h5><span className="badge badge-dark">Pago {datos.ESTATUS_DPG_TEXT}</span></h5>
                                                                                        : datos.ESTATUS_DPG === 5 ?
                                                                                            <h5><span className="badge badge-info">Pago {datos.ESTATUS_DPG_TEXT}</span></h5>
                                                                                            : ''}
                                                            </div>
                                                        </div>
                                                        {/* <div className="col-md-12">
                                                            <div className="form-group">
                                                                <label
                                                                    style={{ fontWeight: 600 }}
                                                                    htmlFor="pnombre"
                                                                >
                                                                    Tipo carnet<span className="text-danger">*</span>
                                                                </label>
                                                                <Select
                                                                    className="form-control form-control-md border border-dark"
                                                                    data-label="Tipo Carnet"
                                                                    placeholder='Seleccionar tipo carnet'
                                                                    id="listTipoCarnet"
                                                                    name="listTipoCarnet"
                                                                    value={selects.listTipoCarnet.clave}
                                                                    datos={catalogos.catTipoCarnets}
                                                                    onChange={({ item }) => {
                                                                        setSelects((s) => ({ ...s, 
                                                                            listTipoCarnet: item
                                                                        }))
                                                                    }}
                                                                />
                                                                <span className={`text-danger txtVacios txtNombre`} style={{ display: 'none' }}>Falta completar (Nombre(s))</span>
                                                            </div>
                                                        </div> */}
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label
                                                                    style={{ fontWeight: 600 }}
                                                                    htmlFor="pnombre"
                                                                >
                                                                    Nombre(s)<span className="text-danger">*</span>
                                                                </label>
                                                                <input
                                                                    className="form-control border border-dark"
                                                                    type="text"
                                                                    defaultValue={datos.NOMBRES_DP}
                                                                    // id={`txtNombre`} 
                                                                    name="txtNombre"
                                                                    placeholder="Nombre(s)"
                                                                />
                                                                <span className={`text-danger txtVacios txtNombre`} style={{ display: 'none' }}>Falta completar (Nombre(s))</span>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label
                                                                    style={{ fontWeight: 600 }}
                                                                    htmlFor="papellidos"
                                                                >
                                                                    Apellidos<span className="text-danger">*</span>
                                                                </label>
                                                                <input
                                                                    className="form-control border border-dark"
                                                                    defaultValue={datos.APELLIDOS_DP}
                                                                    // id={`txtApellidos`} 
                                                                    name="txtApellidos"
                                                                    type="text"
                                                                    placeholder="Apellidos"
                                                                />
                                                                <span className={`text-danger txtVacios txtApellidos`} style={{ display: 'none' }}>Falta completar Apellidos</span>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label
                                                                    style={{ fontWeight: 600 }}
                                                                    htmlFor="pcorreo"
                                                                >
                                                                    Correo Electrónico
                                                                </label>
                                                                <input
                                                                    className="form-control border border-dark"
                                                                    defaultValue={datos.CORREO_DP}
                                                                    // id={`txtCorreo`}
                                                                    name="txtCorreo"
                                                                    type="text"
                                                                    placeholder="Correo Electrónico"
                                                                />
                                                                <span className={`text-danger txtVacios txtCorreo`} style={{ display: 'none' }}>Falta completar Correo Electrónico</span>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label
                                                                    style={{ fontWeight: 600 }}
                                                                    htmlFor="pcorreo"
                                                                >
                                                                    Género
                                                                </label>
                                                                <Select
                                                                    className="form-control form-control-md border border-dark"
                                                                    // tipoValue={1}
                                                                    data-label="Género"
                                                                    placeholder="Seleccionar Género"
                                                                    // id={`listGenero`}
                                                                    name="listGenero"
                                                                    datos={catalogos.catGenero}
                                                                    value={selects.listGenero.clave}
                                                                    onChange={({ item }) => {
                                                                        setSelects((s) => ({ ...s, listGenero: item.clave }))
                                                                    }}
                                                                />
                                                                <span className={`text-danger txtVacios listGenero`} style={{ display: 'none' }}>Falta completar Género</span>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label
                                                                    style={{ fontWeight: 600 }}
                                                                    htmlFor="pcorreo"
                                                                >
                                                                    Whatsapp
                                                                </label>
                                                                <div className="input-group mb-2">
                                                                    <div className="input-group-prepend border border-dark">
                                                                        <div className="input-group-text"><i className="fa fa-whatsapp" aria-hidden="true"></i></div>
                                                                    </div>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control border border-dark"
                                                                        defaultValue={datos.WHATSAPP_DP}
                                                                        // id={`txtWhatsapp`}
                                                                        name="txtWhatsapp"
                                                                        placeholder="Whatsapp"
                                                                    />
                                                                </div>
                                                                <span className={`text-danger txtVacios txtWhatsapp`} style={{ display: 'none' }}>Falta completar Whatsapp</span>
                                                            </div>
                                                        </div>
                                                        {1 == 0 ?
                                                            <Fragment>
                                                                <div className="col-md-6">
                                                                    <div className="form-group">
                                                                        <label
                                                                            style={{ fontWeight: 600 }}
                                                                            htmlFor="Puesto"
                                                                        >
                                                                            Puesto<span className="text-danger">*</span>
                                                                        </label>
                                                                        <Select
                                                                            className="form-control form-control-md border border-dark"
                                                                            data-label="Puesto"
                                                                            placeholder="Seleccionar Puesto"
                                                                            id={`listPuesto`}
                                                                            name="txtPuesto"
                                                                            datos={[
                                                                                { clave: "Dirección", label: "Dirección", value: "Dirección" },
                                                                                { clave: "Administración", label: "Administración", value: "Administración" },
                                                                                { clave: "Contabilidad", label: "Contabilidad", value: "Contabilidad" },
                                                                                { clave: "Operación", label: "Operación", value: "Operación" }
                                                                            ]}
                                                                            value={datosState.listPuesto || datos.PUESTO_DP || ''}
                                                                            onChange={({ item }) => {
                                                                                setDatos((s) => ({ ...s, listPuesto: item.clave }))
                                                                            }}
                                                                        />
                                                                        <span className={`text-danger txtVaciosItem${indice + 1} listPuesto${indice + 1}`} style={{ display: 'none' }}>Falta completar Puesto</span>
                                                                    </div>
                                                                </div>
                                                            </Fragment>
                                                            : ''}
                                                        
                                                        <div className="col-md-12">
                                                            <div className="row d-flex justify-content-end">
                                                                <div className="col-md-3">

                                                                    <button type="button" className="btn btn-primary btn-block mb-4"
                                                                        onClick={() => onClickEnviar()}
                                                                    >Guardar</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* </div>
                </div> */}
            </Fragment>
        </div>
    );
};

export default Default;